export default {
  introduce: '/prop/client/introduce'
}
